import { Injectable } from "@angular/core";
@Injectable()
export class Constants {
  //public API = 'https://178.238.238.202:8080/Skulptur.Api/rest/';
 /* public API = 'https://www.bilumina.com/develApi/rest/';
 // public API_WEB = 'https://178.238.238.202:8080/Skulptur.Web/rest/';
  public API_WEB = 'https://www.bilumina.com/develWeb/rest/';
  //public API_MONITOR = 'https://5.189.152.98:8080/Skulptur.Monitor/rest/';
  public API_MONITOR = 'https://www.bilumina.com/monitor/rest/';
  //public API_FILE_UPLOAD = 'https://5.189.152.98:8080/Circinus-ws/rest/';
  public API_FILE_UPLOAD = 'https://www.bilumina.com/circinus/rest/';

  public ASSETS_CONSTANT = 'https://www.bilumina.com/help/';*/
  /*public API = 'https://www.bilumina.com/develApi/rest/';
  public API_WEB = 'https://www.bilumina.com/develWeb/rest/';
  public API_MONITOR = 'https://www.bilumina.com/monitor/rest/';
  public API_FILE_UPLOAD = 'https://www.bilumina.com/circinus/rest/';
    public API_SALE = '';
  /*
  public API = 'http://172.200.7.125:8080/Skulptur.Api/rest/';
  public API_WEB = 'http://172.200.7.125:8080/Skulptur.Web/rest/';
  public API_MONITOR = 'https://172.200.7.125:8080/Skulptur.Monitor/rest/';
  public API_FILE_UPLOAD = 'https://172.200.7.125:8080/Circinus-ws/rest/';
  //public ASSETS_CONSTANT = 'https://172.200.7.125:8080/webSite/';
  public ASSETS_CONSTANT = 'https://www.bilumina.com/help/';
  public API_SALE = 'http://172.200.7.125:8080/Skulptur.Api/rest/web/';*/

  /*public API = 'http://172.200.7.117:5080/Skulptur.Api/rest/';
  public API_WEB = 'http://172.200.7.117:5080/Skulptur.Web/rest/';
  public API_MONITOR = 'https://172.200.7.117:5080/Skulptur.Monitor/rest/';
  public API_FILE_UPLOAD = 'https://172.200.7.117:5080/Circinus-ws/rest/';
  //public ASSETS_CONSTANT = 'https://172.200.7.125:8080/webSite/';
  public ASSETS_CONSTANT = 'https://www.bilumina.com/help/';
  public API_SALE = 'http://172.200.7.117:5080/Skulptur.Api/rest/web/';*/
  public path = '';
}
